import React from 'react';
import styled from 'styled-components';
import CloseBtn from '@components/dataEntry/button/CloseBtn/CloseBtn';
import { RaidSettingsPanel } from './components/RaidSettings';
import ModalWrapper from '@components/wrapper/Modal/ModalWrapper';
import { ModalInner } from '@components/wrapper/Modal/ModalStyle';

const ModalHeader = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid var(--lineColor);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  background-color: var(--backgroundColor);
  flex-shrink: 0;
`;

const HeaderTitle = styled.h6`
  flex: 1;
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--textColor);
`;
type Props = {
  raidId: string | null;
  onClose: () => void;
};

/**
 * 레이드 상세/설정 모달
 * - RaidSettingsPanel을 재사용하여 편집 기능 제공
 * - 각 탭에 저장 버튼이 내장되어 있음
 */
function RaidDetailModal({ raidId, onClose }: Props) {
  if (!raidId) return null;

  return (
    <ModalWrapper outsideClick={onClose} contentStyle={{ maxWidth: 560, width: '92%' }}>
      <ModalHeader>
        <CloseBtn onClick={onClose} />
        <HeaderTitle>레이드 설정</HeaderTitle>
      </ModalHeader>
      <ModalInner>
        <RaidSettingsPanel raidId={raidId} onSaveComplete={onClose} />
      </ModalInner>
    </ModalWrapper>

  );
}

export default React.memo(RaidDetailModal);
